import React from "react";


const MutualFundThemes = () => {
  return (
    <div className="mutual-fund-container">
      <h2 className="mutual-fund-heading">
        Types of mutual funds themes to invest in
      </h2>

      <div className="fund-section elss-section">
        <img src="https://d17x24txz4ixmz.cloudfront.net/images/mutual-fund-2.webp" alt="ELSS" className="fund-image" />
        <div className="fund-text">
          <h3>ELSS (tax saving funds)</h3>
          <p>Invest in ELSS mutual funds to save on taxes while growing your wealth over time.</p>
        </div>
      </div>

      <div className="fund-section index-section index2">
        <div className="fund-text">
          <h3>Top index funds</h3>
          <p>Top index funds offer a straightforward way to mirror the market's performance with minimal effort.</p>
        </div>
        <img src="https://d17x24txz4ixmz.cloudfront.net/images/mutual-fund-2.webp" alt="Top Index Funds" className="fund-image" />
      </div>
      <div className="fund-section elss-section">
        <img src="https://d17x24txz4ixmz.cloudfront.net/images/mutual-fund-2.webp" alt="ELSS" className="fund-image" />
        <div className="fund-text">
          <h3>ELSS (tax saving funds)</h3>
          <p>Invest in ELSS mutual funds to save on taxes while growing your wealth over time.</p>
        </div>
      </div>
    </div>
  );
};

export default MutualFundThemes;
